import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect } from 'react';

import errorIconImage from 'assets/images/icons/error.svg';

import { LoadingSpinnerProps } from './ErrorIconTypes';
import StyledErrorIcon from './StyledErrorIcon';
import { useIntl } from 'react-intl';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ error }) => {
  const intl = useIntl();

  // need to preload it
  useEffect(() => {
    new Image().src = errorIconImage;
  }, []);

  return (
    <StyledErrorIcon>
      <img className="hidden-image" src={errorIconImage} alt={intl.formatMessage({ id: 'alt.errorIcon' })} />
      <AnimatePresence>
        {error && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <img src={errorIconImage} alt={intl.formatMessage({ id: 'alt.errorIcon' })} />
          </motion.div>
        )}
      </AnimatePresence>
    </StyledErrorIcon>
  );
};

export default LoadingSpinner;
